<template>
    <Main>
        <template #body>
            <div>
                <div class="row gutters">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="profile-header">
                            <h1>Welcome, {{ userInfo && userInfo.name ? userInfo.name : '' }}</h1>
                            <div class="profile-header-content">
                                <div class="profile-header-tiles">
                                    <div class="row gutters">
                                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                                            <div class="profile-tile">
                                                <span class="icon">
                                                    <i class="icon-server"></i>
                                                </span>
                                                <h6>
                                                    Email - <span>{{ userInfo && userInfo.email ? userInfo.email : '' }}</span>
                                                </h6>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                                            <div class="profile-tile">
                                                <span class="icon">
                                                    <i class="icon-map-pin"></i>
                                                </span>
                                                <h6>
                                                    Company - <span>{{ userInfo && userInfo.company_info ? userInfo.company_info.name : '' }}</span>
                                                </h6>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                                            <div class="profile-tile">
                                                <span class="icon">
                                                    <i class="icon-phone1"></i>
                                                </span>
                                                <h6>Phone - <span>1234567890</span></h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="profile-avatar-tile">
                                    <img src="@/assets/img/user.png" class="img-fluid" alt="User Profile" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row gutters">
                    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                        <div class="row gutters">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="card-title">Share your thoughts</div>
                                    </div>
                                    <div class="card-body">
                                        <div class="create-offer-container"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                        <div class="row gutters">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="stats-tile4 min-height">
                                    <div class="stats-icon4">
                                        <i class="icon-receipt"></i>
                                    </div>
                                    <h3>2</h3>
                                    <h4>Certifications</h4>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="stats-tile4 min-height">
                                    <div class="stats-icon4">
                                        <i class="icon-stars"></i>
                                    </div>
                                    <h3>7</h3>
                                    <h4>Awards</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import { generateStorageKey } from '@/utils';
import { USER_INFO_KEY } from '@/config/constants';
export default {
    name: 'home',
    components: {
        Main
    },
    computed: {
        userInfo() {
            let user = this.$cookies.get(generateStorageKey(USER_INFO_KEY));
            return user;
        }
    }
};
</script>
